import React from 'react';
import { identity } from "../../../utils/getIdentity";
import { Modal } from 'antd';
import '../../../layout/Modal.scss';
import Button from "../../Button";
import '../../WalletsPage/WalletDeleteModal.scss';
import { useTranslation } from "react-i18next";
import { ReactComponent as SuccessIcon } from '../../../img/default-svg/success.svg';
import ButtonSuccess from "../../Button";
import { Link } from "react-router-dom";

const CancelSubscriptionModal = ({ visible, close, fetching, handleCancelSubscription, isOpenRedirectModal }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (!isOpenRedirectModal) {
      close()
    }
  };

  return (
    <Modal
      title={null}
      visible={visible}
      onCancel={handleClose}
      footer={null}
      className={`modal modal-${identity}`}
    >
      {!isOpenRedirectModal ? (
        <div className="adminData">
          <div>{t('plans.cancel')}</div>

          <div className="adminData__buttons">
            <Button type="secondary" onClick={close}>
              {t('plans.nope')}
            </Button>
            <Button type="primary" loading={fetching} onClick={handleCancelSubscription}>
              {t('plans.yes')}
            </Button>
          </div>
        </div>
      ) : (
        <div className="adminData">
          <SuccessIcon />
          <div>{t("admin.successful_cancel")}</div>
          <div className="adminData__go">
            <Link to="/">
              <ButtonSuccess>{t("multisendWithdraw.goToTransactions")}</ButtonSuccess>
            </Link>
          </div>

        </div>
      )}
    </Modal>
  )
};

export default CancelSubscriptionModal;